import { useMemo } from 'react';

export interface LoginFooterHook {
  showSocial: boolean;
}

export default function useLoginFooter(): LoginFooterHook {
  const showSocial = useMemo(() => false, []);
  return {
    showSocial,
  };
}
